import * as React from 'react'

import { isHsFormMessageData, isHsMeetingMessageData, UseHsMeetingCallbackParams } from '../interfaces/hubspot'

export const useHsFormCallback = (params: {
  onFormReadyCallback?: (event?: MessageEvent) => void
  onFormSubmittedCallback?: (event?: MessageEvent) => void
  onFormSubmitCallback?: (event?: MessageEvent) => void
  hubspotFormIds: string[]
  deps?: any[]
}) => {
  React.useEffect(() => {
    const messageHandler = (event: MessageEvent) => {
      if (isHsFormMessageData(event.data) && params.hubspotFormIds.includes(event.data.id)) {
        if (event.data.eventName === 'onFormSubmitted' && params.onFormSubmittedCallback) {
          params.onFormSubmittedCallback(event)
        } else if (event.data.eventName === 'onFormReady' && params.onFormReadyCallback) {
          params.onFormReadyCallback(event)
        } else if (event.data.eventName === 'onFormSubmit' && params.onFormSubmitCallback) {
          params.onFormSubmitCallback(event)
        }
      }
    }

    window.addEventListener('message', messageHandler)

    return () => {
      window.removeEventListener('message', messageHandler)
    }
  }, params.deps || [])
}

export const useHsMeetingCallback = ({ onMeetingBooked, deps = [] }: UseHsMeetingCallbackParams) => {
  React.useEffect(() => {
    const messageHandler = (event: MessageEvent) => {
      if (event.origin !== 'https://meetings.hubspot.com') {
        return
      }
      if (isHsMeetingMessageData(event.data)) {
        onMeetingBooked?.(event)
      }
    }

    window.addEventListener('message', messageHandler)
    return () => {
      window.removeEventListener('message', messageHandler)
    }
  }, deps)
}
